import { render } from "./App.vue?vue&type=template&id=5420589b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5420589b&lang=css"

import exportComponent from "D:\\project\\lm-pgac\\PGAC-source\\pgac-600090-ob-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__